export default __webpack_public_path__ + "static/media/logo.ba83d1f4.png";